/**
 * @param {string} target
 * @param {null | {}} params
 * @param {string} container
 * @returns {Promise<unknown>}
 */
export const yaTag = (target, params = null, container = '') => {
  const page = document.body.className.split(' ')[0] || '';
  const yaID = 7831675;

  if (container === 'undefined') container = '';
  target = target
    .replace('$prefix_', `${page.toUpperCase()}_`)
    .replace('$parent_', `${container.toUpperCase()}_`) || null;
  // eslint-disable-next-line
  const counter = ym;

  return new Promise(((resolve, reject) => {
    if (counter) {
      // console.log(`%c [YANDEX_TAG] ${target} || ${params}`, 'color: yellow;');
      try {
        if (params !== null) {
          // eslint-disable-next-line
          ym(yaID, 'reachGoal', target, params);
        } else {
          // eslint-disable-next-line
          ym(yaID, 'reachGoal', target);
        }
      } catch (error) {
        console.error(`[YANDEX_TAG] ERROR ${error}`);
      }
      resolve();
    } else {
      console.error(`%c [YANDEX_TAG] NO_COUNTER ${target} || ${params}`, 'color: red;');
      reject();
    }
  }));
};
